<wbo-search-page (prepareInitialFilter)="prepareInitialFilter()" [editParams]="extendedSearchParams?.searchParams">
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="name">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="type" *ngIf="showTypeFilter">
                <wbo-single-select-search-control initialDefaultValue="all" [allowClearSelectionOption]="false">
                    <wbo-select-options>
                        <wbo-select-option value="all" label="wbo.preparation-modifier.option.modifier-type.all"></wbo-select-option>
                        <wbo-select-option label="wbo.preparation-modifier.option.modifier-type.preparation" value="preparation"></wbo-select-option>
                        <wbo-select-option label="wbo.preparation-modifier.option.modifier-type.message" value="prepared message"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="name"></wbo-main-search-column>
        <wbo-column field="type"></wbo-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
